<div
	class="modal-backdrop"
	role="dialog"
	aria-modal="true"
	aria-label="Free preview limit reached"
>
	<section class="limit-modal">
		<span class="status-badge warning">Limit reached</span>
		<h2>More deployment capacity is coming soon.</h2>
		<p>
			App Launcher currently supports one active deployment per account.
		</p>
		<p>
			To launch another app, request expanded access and tell us what you
			need next.
		</p>
		<div class="button-row">
			<button class="secondary-button" type="button" (click)="remove()">
				Remove deployment
			</button>
			<button
				class="primary-button"
				type="button"
				(click)="requestAccess()"
			>
				Request expanded access
			</button>
		</div>
	</section>
</div>
